import { SHAQ_HOME_TAKEOVER_EXPERIMENT } from '~/constants/common/shaqHomeTakeover';
import useIsInExperiment from './useIsInExperiment';

export default function useIsInShaqHomeTakeoverExperiment() {
  return useIsInExperiment(SHAQ_HOME_TAKEOVER_EXPERIMENT, 'treatment');
}
